import { Button } from "./Button";
export const MemoInput = ({ text, onChange, onClick }) => {
  return (
    <div className="input-area">
      {/* 入力値は親コンポーネントで管理 */}
      <input
        value={text}
        onChange={onChange}
        placeholder="テキストを入力"
      />

      {/* 親から受け取った関数を実行 */}
      <Button onClick={onClick}>
        追加
      </Button>
    </div>
  );
};